;(function () {
	const productMarkers = () => {
		$(document).ready(function () {
			let originalPositions = {}

			function updateMobileMarkerPositions() {
				if (window.innerWidth <= 989) {
					$('.js-product-markers__item').each(function () {
						const marker = $(this)
						const markerIndex = marker.data('index')
						const mobileX = marker.data('mobile-x')
						const mobileY = marker.data('mobile-y')
						const mobileHorizontal = marker.data('mobile-horizontal')
						const mobileVertical = marker.data('mobile-vertical')

						if (!originalPositions[markerIndex]) {
							originalPositions[markerIndex] = {
								style: marker.attr('style'),
								left: marker.css('left'),
								right: marker.css('right'),
								top: marker.css('top'),
								bottom: marker.css('bottom'),
							}
						}

						if (mobileX !== undefined && mobileY !== undefined) {
							marker.css({
								left: '',
								right: '',
								top: '',
								bottom: '',
							})

							marker.css({
								[mobileHorizontal]: mobileX + '%',
								[mobileVertical]: mobileY + '%',
							})
						}
					})
				} else {
					$('.js-product-markers__item').each(function () {
						const marker = $(this)
						const markerIndex = marker.data('index')

						if (originalPositions[markerIndex]) {
							marker.attr('style', originalPositions[markerIndex].style)
						}
					})
				}
			}

			updateMobileMarkerPositions()
			$(window).on('resize', updateMobileMarkerPositions)

			$('.js-product-markers__item').click(function () {
				$('.product-markers__img-box').css({
					borderTopLeftRadius: '0px',
					borderTopRightRadius: '0px',
				})

				$('.product-markers-for-mobile .js-product-markers__item-inner').each(
					function (index) {
						$(this).css({ display: 'none' })
					}
				)

				$(
					`.product-markers-for-mobile .js-product-markers__item-inner[data-index='${$(
						this
					).data('index')}']`
				).css({
					display: 'block',
				})
			})

			$('.js-product-markers__item').hover(
				function () {
					const marker = $(this)
					const tooltip = marker.find('.card-wrapper')

					const tooltipRect = tooltip[0].getBoundingClientRect()
					const boxRect = $('.product-markers__img-box')[0].getBoundingClientRect()

					if (window.innerWidth > 989) {
						marker.addClass('product-markers__card-goToTop')
					} else {
						if (tooltipRect.right > boxRect.right) {
							marker.addClass('product-markers__card-goToLeft')
						}

						if (tooltipRect.bottom >= boxRect.bottom) {
							marker.addClass('product-markers__card-goToTop')
						}

						if (tooltipRect.top <= boxRect.top) {
							marker.addClass('product-markers__card-goToBottom')
						}
					}
				},
				function () {
					const marker = $(this)
					marker.removeClass(
						'product-markers__card-goToLeft product-markers__card-goToTop product-markers__card-goToBottom'
					)
				}
			)
		})
	}

	document.addEventListener('DOMContentLoaded', function () {
		productMarkers()
		document.addEventListener('shopify:section:load', function () {
			productMarkers()
		})
	})
})()
